import { FieldHookConfig, useField } from "formik";

import { TextInput, TextInputProps } from "@sso/components/Form";

export const FormikTextInput = (props: FieldHookConfig<string> & TextInputProps) => {
  const [field, meta] = useField(props);
  const err = Boolean(meta.touched && meta.error);
  return <TextInput id={props.name} {...field} {...props} error={err} errorText={err ? meta.error : null} />;
};
